import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}`;
export const brandService = {
    getBrandDetails,
    updateBrandDetails,
    savePointOfContact,
    updateBrandUserPassword,
    getBrandDashboardSummary
};

function getBrandDetails(id) {
    return fetchWrapper.get(`${baseUrl}/users/${id}`);
}
function updateBrandDetails(id, params) {
    return fetchWrapper.put(
        `${process.env.REACT_APP_API_URL}/brands/user_id/${id}`,
        params
    );
}
function savePointOfContact(id, params) {
    return fetchWrapper.put(
        `${process.env.REACT_APP_API_URL}/contact-info/user_id/${id}`,
        params
    );
}
function updateBrandUserPassword(id, params) {
    return fetchWrapper.put(
        `${process.env.REACT_APP_API_URL}/users/reset-password/${id}`,
        params
    );
}
function getBrandDashboardSummary() {
    return fetchWrapper.get(`${baseUrl}/brand/dashboard/summary`);
}

